angular.module('mychart').factory('ChartRepository',
    ['AprimaRestangular', 'MetadataRepository', function (AprimaRestangular, MetadataRepository) {
        'use strict';

        var getAccessLog = function getAccessLog(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + uid + '/ccd/access-log').get();
        };

        var getDirectMailUsers = function getDirectMailUsers(uid){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + uid + '/ccd/provider-list').get();
        };

        var postTransmitRequest = function postTransmitRequest(transferDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + transferDto.PatientId + '/uscdiccd/transfer').customPOST(transferDto);
        };

        function getCCDHtml(patientId, dateFilter) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + patientId + '/uscdiccd').customGET('html', dateFilter);
        }

        function postCCDHtmlDownloaded(reportRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + reportRequestDto.PatientId + '/ccd/html').customPOST(reportRequestDto);
        }

        function getCDAXml(patientId, dateFilter) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + patientId + '/uscdiccd').customGET('xml', dateFilter);
        }

        function getTransferCcdMetadata($scope) {
            return MetadataRepository.getMetadata('transfer-ccd', $scope);
        }

        function getTransmitCcdConfig(patientId){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('chart/' + patientId + '/ccd/transfer-config').get();
        }




        return {
            getAccessLog: getAccessLog,
            getDirectMailUsers: getDirectMailUsers,
            postTransmitRequest: postTransmitRequest,
            getCCDHtml: getCCDHtml,
            postCCDHtmlDownloaded: postCCDHtmlDownloaded,
            getCDAXml: getCDAXml,
            getTransferCcdMetadata: getTransferCcdMetadata,
            getTransmitCcdConfig: getTransmitCcdConfig,

        };
    }]);

